import { Box } from "@chakra-ui/react";
import * as React from "react";

export function SimpleBlock({ children, maxW = "600px" }) {
  return (
    <>
      <Box w="full">
        <Box margin="0 auto" maxW={maxW} w="full">
          {children}
        </Box>
      </Box>
    </>
  );
}
